/**
 * Generated runtime TestId mirror for frontend/src/pages/reporting/SqlAssistPanel.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const SqlAssistPanelTestIds = {
  btnApplySuggestion: "btn-apply-suggestion",
  btnSuggestSql: "btn-suggest-sql",
  btnToggleAssist: "btn-toggle-assist",
  inputAssistRequest: "input-assist-request",
  selectModel: "select-model",
  suggestedSqlPreview: "suggested-sql-preview"
} as const;
